import React, { useState, useEffect, useContext, useRef } from 'react';
import { CONTENT_WIDTH } from "../../constants/layout";
import { 
    Box, 
    Typography, 
    Grid, 
    Tab, 
    TabList, 
    TabPanel, 
    Tabs,
    useTheme,
    Snackbar,
    Modal,
    ModalDialog,
    ModalClose,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    CircularProgress
} from '@mui/joy';
import axios from 'axios';
import CustomInput from "../../components/UI/custom_elements/customInput";
import PrimaryButton from "../../components/UI/custom_elements/primaryButton";
import SecondaryButton from "../../components/UI/custom_elements/secondaryButton";
import HeadTable from "../../components/UI/custom_elements/headTable";
import SessionContext from "../../store";

// Iconos
const EyeIcon = ({ color = "#082B39" }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42 13.98 8.42 12C8.42 10.02 10.02 8.41998 12 8.41998C13.98 8.41998 15.58 10.02 15.58 12Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.47 3.71997 5.18 5.79997 2.89 9.39997C1.99 10.81 1.99 13.18 2.89 14.59C5.18 18.19 8.47 20.27 12 20.27Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const CopyIcon = ({ color = "#082B39" }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 13.4V16.4C17 20.4 15.4 22 11.4 22H7.6C3.6 22 2 20.4 2 16.4V12.6C2 8.6 3.6 7 7.6 7H10.6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17 13.4H13.8C11.4 13.4 10.6 12.6 10.6 10.2V7L17 13.4Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.6 2H15.6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7 5C7 3.34 8.34 2 10 2H12.62" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 8V14.19C22 15.74 20.74 17 19.19 17" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22 8H19C16.75 8 16 7.25 16 5V2L22 8Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const PolygonIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="white"/>
        <g clipPath="url(#clip0_2624_3374)">
            <path d="M20.9865 12.7229C20.6362 12.5227 20.1859 12.5227 19.7856 12.7229L16.9837 14.374L15.0823 15.4248L12.3303 17.076C11.9801 17.2761 11.5298 17.2761 11.1295 17.076L8.97797 15.775C8.62772 15.5749 8.37754 15.1746 8.37754 14.7243V12.2225C8.37754 11.8222 8.57768 11.422 8.97797 11.1718L11.1295 9.92088C11.4797 9.72074 11.9301 9.72074 12.3303 9.92088L14.4819 11.2218C14.8321 11.422 15.0823 11.8222 15.0823 12.2726V13.9237L16.9837 12.8229V11.1217C16.9837 10.7215 16.7835 10.3212 16.3832 10.071L12.3804 7.71932C12.0301 7.51918 11.5798 7.51918 11.1795 7.71932L7.07662 10.121C6.67633 10.3212 6.47619 10.7215 6.47619 11.1217V15.8251C6.47619 16.2254 6.67633 16.6256 7.07662 16.8758L11.1295 19.2275C11.4797 19.4276 11.9301 19.4276 12.3303 19.2275L15.0823 17.6264L16.9837 16.5256L19.7356 14.9244C20.0859 14.7243 20.5362 14.7243 20.9365 14.9244L23.088 16.1753C23.4382 16.3755 23.6884 16.7758 23.6884 17.2261V19.7278C23.6884 20.1281 23.4883 20.5284 23.088 20.7786L20.9865 22.0295C20.6362 22.2296 20.1859 22.2296 19.7856 22.0295L17.6341 20.7786C17.2839 20.5785 17.0337 20.1782 17.0337 19.7278V18.1267L15.1323 19.2275V20.8787C15.1323 21.279 15.3325 21.6792 15.7328 21.9294L19.7856 24.2811C20.1359 24.4812 20.5862 24.4812 20.9865 24.2811L25.0394 21.9294C25.3896 21.7293 25.6398 21.329 25.6398 20.8787V16.1253C25.6398 15.725 25.4397 15.3247 25.0394 15.0745L20.9865 12.7229Z" fill="#8247E5"/>
        </g>
        <defs>
            <clipPath id="clip0_2624_3374">
                <rect width="19.2136" height="16.7619" fill="white" transform="translate(6.47619 7.61902)"/>
            </clipPath>
        </defs>
    </svg>
);

const AdminPage = () => {
    const theme = useTheme();
    const { session } = useContext(SessionContext);
    
    const dataFetchedRef = useRef(false);
    
    const [activeTab, setActiveTab] = useState(0);
    
    // Balance & Withdrawal states
    const [availableBalance, setAvailableBalance] = useState('0.0000');
    const [loadingBalance, setLoadingBalance] = useState(true);
    
    // Fondeo states
    const [fundingWalletAddress, setFundingWalletAddress] = useState('');
    const [fundingDialogOpen, setFundingDialogOpen] = useState(false);
    const [addressRevealed, setAddressRevealed] = useState(false);
    
    // Operators states
    const [operators, setOperators] = useState([]);
    const [loadingOperators, setLoadingOperators] = useState(false);
    
    // Modal states
    const [modalOpen, setModalOpen] = useState(false);
    const [operatorUsername, setOperatorUsername] = useState('');
    const [operatorPassword, setOperatorPassword] = useState('');
    const [loadingOperator, setLoadingOperator] = useState(false);
    
    // Generate User modal states
    const [generateUserModalOpen, setGenerateUserModalOpen] = useState(false);
    const [newUser, setNewUser] = useState({
        username: '',
        password: '',
        type: 'operator',
        email: ''
    });
    const [loadingGenerateUser, setLoadingGenerateUser] = useState(false);
    
    // Messages
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const operatorHeads = ["Username", "Source", "Tipo"];

    const fetchBalance = async () => {
        setLoadingBalance(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_URL_API_CRIXTO}orders/transactions/v2/balance`,
                {
                    headers: {
                        'Authorization': `Bearer ${session.token}`
                    }
                }
            );
            if (response.data && response.data.data) {
                setAvailableBalance(truncateToDecimals(parseFloat(response.data.data.available), 6));
                if (response.data.data.wallet) {
                    setFundingWalletAddress(response.data.data.wallet);
                }
            }
        } catch (error) {
            setErrorMessage('Error al obtener el saldo disponible');
        } finally {
            setLoadingBalance(false);
        }
    };

    const fetchOperators = async () => {
        setLoadingOperators(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_URL_API_CRIXTO}orders/operators`,
                {
                    headers: {
                        'Authorization': `Bearer ${session.token}`
                    }
                }
            );
            if (response.data && response.data.data) {
                setOperators(response.data.data);
            } else if (response.data && Array.isArray(response.data)) {
                setOperators(response.data);
            }
        } catch (error) {
            setErrorMessage('Error al obtener la lista de operadores');
        } finally {
            setLoadingOperators(false);
        }
    };

    useEffect(() => {
        if (dataFetchedRef.current) return;
        
        fetchBalance();
        fetchOperators();
        dataFetchedRef.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.token]);

    const formatAmountUSDT = (value) => {
        const numValue = typeof value === 'string' ? parseFloat(value) : value;
        return new Intl.NumberFormat('es-ES', {
            minimumFractionDigits: 6,
            maximumFractionDigits: 6
        }).format(numValue || 0);
    };

    // Fondeo handlers
    const handleOpenFundingDialog = () => {
        setAddressRevealed(false);
        setFundingDialogOpen(true);
    };

    const truncateToDecimals = (num, decimals) => {
        const factor = Math.pow(10, decimals);
        return Math.trunc(num * factor) / factor;
    };

    const handleRevealAddress = () => {
        setAddressRevealed(true);
    };

    const handleCopyAddress = async () => {
        try {
            await navigator.clipboard.writeText(fundingWalletAddress);
            setSuccessMessage('Dirección copiada al portapapeles');
        } catch (error) {
            setErrorMessage('Error al copiar la dirección');
        }
    };

    // Operator handlers
    const openCreateModal = () => {
        setOperatorUsername('');
        setOperatorPassword('');
        setModalOpen(true);
    };

    // Generate User handlers
    const openGenerateUserModal = () => {
        setNewUser({
            username: '',
            password: '',
            type: 'operator',
            email: ''
        });
        setGenerateUserModalOpen(true);
    };

    const handleGenerateUser = async () => {
        if (!newUser.username.trim()) {
            setErrorMessage('Por favor ingrese el nombre de usuario');
            return;
        }
        if (!newUser.password.trim()) {
            setErrorMessage('Por favor ingrese la contraseña');
            return;
        }
        if (!newUser.email.trim()) {
            setErrorMessage('Por favor ingrese el email');
            return;
        }

        setLoadingGenerateUser(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_URL_API}/orders/operators`,
                {
                    username: newUser.username,
                    password: newUser.password,
                    email: newUser.email
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${session.token}`
                    }
                }
            );

            if (response.data && response.data.success) {
                setSuccessMessage('Usuario generado exitosamente');
                setGenerateUserModalOpen(false);
                fetchOperators();
                setNewUser({
                    username: '',
                    password: '',
                    source: '',
                    type: 'operator',
                    email: ''
                });
            } else {
                setErrorMessage(response.data?.message || 'Error al generar el usuario');
            }
        } catch (error) {
            if (error.response && error.response.data) {
                setErrorMessage(error.response.data.message || error.response.data.errorMessage || 'Error al generar el usuario');
            } else {
                setErrorMessage('Error al generar el usuario');
            }
        } finally {
            setLoadingGenerateUser(false);
        }
    };

    const handleCreateOperator = async () => {
        if (!operatorUsername.trim()) {
            setErrorMessage('Por favor ingrese el nombre de usuario');
            return;
        }
        if (!operatorPassword.trim()) {
            setErrorMessage('Por favor ingrese la contraseña');
            return;
        }

        setLoadingOperator(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_URL_API_CRIXTO}orders/operators`,
                {
                    username: operatorUsername,
                    password: operatorPassword
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${session.token}`
                    }
                }
            );

            if (response.data && response.data.success) {
                setSuccessMessage('Operador creado exitosamente');
                setModalOpen(false);
                await fetchOperators();
            } else {
                setErrorMessage(response.data?.message || 'Error al crear el operador');
            }
        } catch (error) {
            if (error.response && error.response.data) {
                setErrorMessage(error.response.data.message || error.response.data.errorMessage || 'Error al crear el operador');
            } else {
                setErrorMessage('Error al crear el operador');
            }
        } finally {
            setLoadingOperator(false);
        }
    };

    return (
        <Box mx={5} my={2} sx={{ width: CONTENT_WIDTH }}>
            <Snackbar
                open={!!errorMessage}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                variant="solid"
                color="danger"
                autoHideDuration={4000}
                onClose={() => setErrorMessage('')}
            >
                {errorMessage}
            </Snackbar>
            
            <Snackbar
                open={!!successMessage}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                variant="solid"
                color="success"
                autoHideDuration={4000}
                onClose={() => setSuccessMessage('')}
            >
                {successMessage}
            </Snackbar>

            {/* Modal Fondeo - Red Polygon */}
            <Modal open={fundingDialogOpen} onClose={() => setFundingDialogOpen(false)}>
                <ModalDialog 
                    variant="plain" 
                    sx={{ 
                        minWidth: 550,
                        maxWidth: 550,
                        borderRadius: '24px',
                        backgroundColor: '#E0FAFA',
                        p: 4
                    }}
                >
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Typography sx={{ 
                            fontFamily: "Montserrat", 
                            fontSize: "20px", 
                            fontWeight: 700, 
                            color: '#082B39',
                            mb: 3
                        }}>
                            Muney usa la red
                        </Typography>
                        
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            px: 3,
                            py: 1.5,
                            mb: 3
                        }}>
                            <PolygonIcon />
                            <Typography sx={{ 
                                fontFamily: "Montserrat", 
                                fontSize: "16px", 
                                fontWeight: 600, 
                                color: '#082B39'
                            }}>
                                Polygon
                            </Typography>
                        </Box>

                        <Typography sx={{ 
                            fontFamily: "Montserrat", 
                            fontSize: "14px", 
                            color: '#082B39',
                            textAlign: 'center',
                            mb: 3,
                            lineHeight: 1.6
                        }}>
                            Asegúrate de utilizar esta red en las transacciones de tu cuenta para poder darte el seguimiento y apoyo en los fondos y retiros que hagas.
                        </Typography>

                        {addressRevealed ? (
                            <Box sx={{ width: '100%', mb: 3 }}>
                                <Typography sx={{ 
                                    fontFamily: "Montserrat", 
                                    fontSize: "14px", 
                                    fontWeight: 600,
                                    color: '#082B39',
                                    mb: 1
                                }}>
                                    Dirección de billetera
                                </Typography>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 1,
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    px: 2,
                                    py: 1.5
                                }}>
                                    <Typography 
                                        onClick={handleCopyAddress}
                                        sx={{ 
                                            fontFamily: "Montserrat", 
                                            fontSize: "11px", 
                                            color: '#082B39',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            cursor: fundingWalletAddress ? 'pointer' : 'default',
                                            '&:hover': fundingWalletAddress ? {
                                                color: '#18E9E9'
                                            } : {}
                                        }}
                                    >
                                        {fundingWalletAddress || 'Cargando...'}
                                    </Typography>
                                    <Box 
                                        onClick={handleCopyAddress}
                                        sx={{ 
                                            cursor: fundingWalletAddress ? 'pointer' : 'not-allowed', 
                                            flexShrink: 0,
                                            opacity: fundingWalletAddress ? 1 : 0.5,
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <CopyIcon />
                                    </Box>
                                </Box>
                                <Typography sx={{ 
                                    fontFamily: "Montserrat", 
                                    fontSize: "12px", 
                                    color: '#F20E25',
                                    mt: 1
                                }}>
                                    Asegúrate de seleccionar la red <strong>Polygon</strong> al momento de hacer el fondeo de tu billetera Muney.
                                </Typography>
                            </Box>
                        ) : (
                            <Box 
                                onClick={handleRevealAddress}
                                sx={{
                                    width: '100%',
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    py: 2,
                                    px: 3,
                                    cursor: 'pointer',
                                    mb: 3,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    border: '1px solid #E0E0E0',
                                    '&:hover': {
                                        backgroundColor: '#F5F5F5'
                                    }
                                }}
                            >
                                <Typography sx={{ 
                                    fontFamily: "Montserrat", 
                                    fontSize: "16px", 
                                    fontWeight: 600, 
                                    color: '#082B39'
                                }}>
                                    Aceptar
                                </Typography>
                            </Box>
                        )}

                        {addressRevealed && (
                            <Typography sx={{ 
                                fontFamily: "Montserrat", 
                                fontSize: "13px", 
                                color: '#082B39',
                                fontWeight: 500
                            }}>
                                Fondeo en USDT
                            </Typography>
                        )}
                    </Box>
                </ModalDialog>
            </Modal>

            {/* Modal Crear Operador */}
            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <ModalDialog variant="outlined" sx={{ minWidth: 400 }}>
                    <ModalClose />
                    <DialogTitle sx={{ fontFamily: "Montserrat", fontWeight: 700, color: theme.vars.palette.primary["500"] }}>
                        Crear Operador
                    </DialogTitle>
                    <Divider />
                    <DialogContent sx={{ mt: 2 }}>
                        <Box mb={3}>
                            <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                Nombre de Usuario
                            </Typography>
                            <CustomInput
                                placeholder="Ingrese el username"
                                width="100%"
                                value={operatorUsername}
                                setValue={setOperatorUsername}
                            />
                        </Box>
                        <Box>
                            <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                Contraseña
                            </Typography>
                            <CustomInput
                                placeholder="Ingrese la contraseña"
                                width="100%"
                                value={operatorPassword}
                                setValue={setOperatorPassword}
                                password={true}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <SecondaryButton click={() => setModalOpen(false)} text="Cancelar" />
                        <PrimaryButton 
                            click={handleCreateOperator} 
                            text="Crear" 
                            loading={loadingOperator}
                            desactived={!operatorUsername || !operatorPassword}
                        />
                    </DialogActions>
                </ModalDialog>
            </Modal>

            {/* Modal Generar Usuario */}
            <Modal open={generateUserModalOpen} onClose={() => setGenerateUserModalOpen(false)}>
                <ModalDialog variant="outlined" sx={{ 
                    minWidth: 500, 
                    overflow: 'hidden',
                    '& .MuiDialogContent-root': {
                        overflow: 'hidden !important',
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    }
                }}>
                    <ModalClose />
                    <DialogTitle sx={{ fontFamily: "Montserrat", fontWeight: 700, color: theme.vars.palette.primary["500"] }}>
                        Generar Usuario
                    </DialogTitle>
                    <Divider />
                    <DialogContent sx={{ 
                        mt: 2, 
                        overflow: 'hidden !important',
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        maxHeight: 'none'
                    }}>
                        <Grid container spacing={2}>
                            <Grid xs={12} mt={1}>
                                <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                    Nombre de Usuario
                                </Typography>
                                <CustomInput
                                    placeholder="name"
                                    width="100%"
                                    value={newUser.username}
                                    setValue={(value) => setNewUser(prev => ({ ...prev, username: value }))}
                                />
                            </Grid>
                            <Grid xs={12}>
                                <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                    Contraseña
                                </Typography>
                                <CustomInput
                                    placeholder="Ingrese la contraseña"
                                    width="100%"
                                    value={newUser.password}
                                    setValue={(value) => setNewUser(prev => ({ ...prev, password: value }))}
                                    password={true}
                                />
                            </Grid>
                            <Grid xs={12}>
                                <Typography mb={1} sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                    Email
                                </Typography>
                                <CustomInput
                                    placeholder="main@mail.com"
                                    width="100%"
                                    value={newUser.email}
                                    setValue={(value) => setNewUser(prev => ({ ...prev, email: value }))}
                                    type="email"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <SecondaryButton click={() => setGenerateUserModalOpen(false)} text="Cancelar" />
                        <PrimaryButton 
                            click={handleGenerateUser} 
                            text="Generar Usuario" 
                            loading={loadingGenerateUser}
                            desactived={!newUser.username || !newUser.password || !newUser.email}
                        />
                    </DialogActions>
                </ModalDialog>
            </Modal>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography sx={{
                    fontFamily: "Montserrat",
                    fontSize: "20px",
                    fontWeight: 700,
                    lineHeight: "120%",
                    color: theme.vars.palette.primary["500"],
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                }}>
                    Administración - {loadingBalance ? (
                        <CircularProgress size="sm" />
                    ) : (
                        `${formatAmountUSDT(availableBalance)} USDT`
                    )}
                </Typography>
                <PrimaryButton 
                    click={openGenerateUserModal} 
                    text="+ Generar Usuario" 
                />
            </Box>

            <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)} sx={{ width: '100%' }}>
                <TabList sx={{ mb: 3 }}>
                    <Tab sx={{ fontFamily: "Montserrat", fontWeight: 600, color: theme.vars.palette.primary["500"] }}>
                        Saldo y Retiros
                    </Tab>
                    <Tab sx={{ fontFamily: "Montserrat", fontWeight: 600, color: theme.vars.palette.primary["500"] }}>
                        Operadores
                    </Tab>
                </TabList>

                {/* Tab Saldo y Retiros */}
                <TabPanel value={0} sx={{ p: 0 }}>
                    <Box sx={{ p: 4, backgroundColor: theme.vars.palette.background.surface, borderRadius: '12px' }}>
                        {/* Saldo disponible */}
                        <Box sx={{ mb: 4, p: 3, borderRadius: "12px", backgroundColor: theme.vars.palette.background.level1, border: `1px solid ${theme.vars.palette.neutral[200]}` }}>
                            <Typography sx={{ fontFamily: "Montserrat", fontSize: "16px", fontWeight: 500, color: theme.vars.palette.text.main, mb: 1 }}>
                                Saldo Disponible
                            </Typography>
                            {loadingBalance ? (
                                <Box display="flex" alignItems="center" gap={2}>
                                    <CircularProgress size="md" />
                                    <Typography sx={{ fontFamily: "Montserrat", fontSize: "18px", color: theme.vars.palette.text.secondary }}>
                                        Cargando saldo...
                                    </Typography>
                                </Box>
                            ) : (
                                <Typography sx={{ fontFamily: "Montserrat", fontSize: "32px", fontWeight: 700, color: theme.vars.palette.primary["500"] }}>
                                    {formatAmountUSDT(availableBalance)} USDT
                                </Typography>
                            )}
                        </Box>

                        {/* Sección Fondeo */}
                        <Box sx={{ mb: 4, p: 3, borderRadius: "12px", backgroundColor: theme.vars.palette.background.level1, border: `1px solid ${theme.vars.palette.neutral[200]}` }}>
                            <Typography sx={{ fontFamily: "Montserrat", fontSize: "16px", fontWeight: 600, color: theme.vars.palette.text.main, mb: 2 }}>
                                Dirección de billetera para fondeo en USDT
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography sx={{ 
                                    fontFamily: "Montserrat", 
                                    fontSize: "14px", 
                                    color: theme.vars.palette.text.primary,
                                    letterSpacing: '2px'
                                }}>
                                    ● ● ● ● ● ● ● ● ● ●
                                </Typography>
                                <Box 
                                    onClick={handleOpenFundingDialog}
                                    sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                                >
                                    <EyeIcon color={theme.vars.palette.text.main} />
                                </Box>
                            </Box>
                            <Typography sx={{ 
                                fontFamily: "Montserrat", 
                                fontSize: "12px", 
                                color: '#F20E25',
                                mt: 1
                            }}>
                                Asegúrate de seleccionar la red <strong>Polygon</strong> al momento de hacer el fondeo de tu billetera Muney.
                            </Typography>
                        </Box>

                        {/* Sección Realizar Retiro - Reemplazada por card de contacto */}
                        <Typography sx={{ fontFamily: "Montserrat", fontSize: "18px", fontWeight: 600, color: theme.vars.palette.text.main, mb: 3 }}>
                            Realizar Retiro
                        </Typography>

                        <Box sx={{ 
                            p: 4, 
                            borderRadius: "12px", 
                            backgroundColor: theme.vars.palette.background.level1, 
                            border: `1px solid ${theme.vars.palette.neutral[200]}`,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Typography sx={{ 
                                fontFamily: "Montserrat", 
                                fontSize: "16px", 
                                fontWeight: 500, 
                                color: theme.vars.palette.text.primary,
                                textAlign: 'center'
                            }}>
                                Comunícate con el administrador
                            </Typography>
                        </Box>
                    </Box>
                </TabPanel>

                {/* Tab Operadores */}
                <TabPanel value={1} sx={{ p: 0 }}>
                    <Box sx={{ p: 4, backgroundColor: theme.vars.palette.background.surface, borderRadius: '12px' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography sx={{ fontFamily: "Montserrat", fontSize: "18px", fontWeight: 600, color: theme.vars.palette.text.main }}>
                                Gestión de Operadores
                            </Typography>
                            <PrimaryButton click={openCreateModal} text="+ Nuevo Operador" />
                        </Box>

                        <HeadTable heads={operatorHeads} theme={theme} />

                        <Box mt={2}>
                            {loadingOperators ? (
                                <Box display="flex" justifyContent="center" alignItems="center" mt={4} gap={2}>
                                    <CircularProgress size="sm" />
                                    <Typography sx={{ fontFamily: "Montserrat", color: theme.vars.palette.text.secondary }}>
                                        Cargando operadores...
                                    </Typography>
                                </Box>
                            ) : operators.length > 0 ? (
                                operators.map((operator, index) => (
                                    <Grid
                                        key={operator.id || index}
                                        container
                                        spacing={2}
                                        mb={2}
                                        columns={3}
                                        sx={{
                                            borderRadius: "12px",
                                            padding: "16px 12px",
                                            backgroundColor: theme.vars.palette.card || "#FFFFFF",
                                            alignItems: "center"
                                        }}
                                    >
                                        <Grid xs={1} display="flex" justifyContent="center">
                                            <Typography sx={{ fontFamily: "Montserrat", fontSize: "14px", fontWeight: 500, color: theme.vars.palette.text.main }}>
                                                {operator.username}
                                            </Typography>
                                        </Grid>
                                        <Grid xs={1} display="flex" justifyContent="center">
                                            <Typography sx={{ fontFamily: "Montserrat", fontSize: "14px", color: theme.vars.palette.text.main }}>
                                                {operator.source || '-'}
                                            </Typography>
                                        </Grid>
                                        <Grid xs={1} display="flex" justifyContent="center">
                                            <Typography sx={{ 
                                                fontFamily: "Montserrat", 
                                                fontSize: "13px", 
                                                fontWeight: 500,
                                                color: operator.type === 'admin' ? theme.vars.palette.primary["500"] : theme.vars.palette.text.main,
                                                textTransform: 'capitalize'
                                            }}>
                                                {operator.type || '-'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                ))
                            ) : (
                                <Box display="flex" justifyContent="center" mt={4}>
                                    <Typography sx={{ fontFamily: "Montserrat", color: theme.vars.palette.text.secondary }}>
                                        No hay operadores registrados
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </TabPanel>
            </Tabs>
        </Box>
    );
};

export default AdminPage;